import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@cavo-admin/auth';

@Component({
	selector: 'cavo-admin-callback',
	template: '',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallbackComponent implements OnInit {
	private authService = inject(AuthService);

	ngOnInit() {
		this.authService.handleAuthCallback();
	}
}
